// extracted by mini-css-extract-plugin
module.exports = {"banner":"ConsentBanner_banner__2ka3G"};